<template> 
 <div style="font-family:'微软雅黑';">
     
  <div id="topPart">
      <myhead></myhead>
  </div>
  <div id="navBar" :class="{isFixed:istabBar}">
       <!--头部第二层的样式-->
         <div class="header2">
            <div class="header2-1">
              <div @click="quBaoming=1"  ><div @click="$router.push('/')"><img width="200px" src="../../assets/logo/ss.gif" alt=""></div></div>
              <div class="header2-1-2">
                  <div @click="tId(item.id)"><a href="#CurriculumBG" @click="quBaoming=1">课程背景</a> </div>
                  <div @click="tId(item.id)"  v-if="data1.course!=''"  > <a href="#Livebroadcastcontent"  @click="quBaoming=1">直播内容</a> </div>
                  <div @click="tId(item.id)"><a href="#keynotespeaker"  @click="quBaoming=1">主讲嘉宾</a> </div>
                  <div @click="tId(item.id)"  v-if="data1.sponsor !=''"  ><a href="#sponsor"  @click="quBaoming=1">赞助单位</a> </div>
                  <div @click="tId(item.id)"><a href="#Applicationnotes"  @click="quBaoming=1">报名须知</a> </div>
                  <div @click="tId(item.id)"  v-if="checked"><a href="#Videorebroadcast"  @click="quBaoming=1">视频回播</a> </div>
              </div>
              <div @click="baom(data1.special.id)" class="header2-btn">立即报名</div>
            </div>
         </div> 
  </div>
  <div id="mainPart">
      <!-- banner -->
      <div style="height:50px;width:100%;"></div>
   <img :src="'http://upload.lusenky.com/'+data1.special.introduction2"  alt="" class="bannerimg">
   <ul id="oTable" v-if="quBaoming==1">
       <!-- 课程背景 -->
       <li id="CurriculumBG"  style="padding-bottom:60px;">
        <div >
        <div  class="ke">
            <div style="text-align:center">
             <div class="ke-jie">课程背景<div class="ke-t"><div></div><div></div><div></div></div></div>
             <div class="ke-jie-1">CURRICULUM</div>
            </div>
            <div v-if="data1.special!==undefined" class="ke-jian">
               <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{data1.special.introduction}}
              </p>
            </div>
          </div>
        </div>
       </li>
       <!-- 直播内容 -->
       <li id="Livebroadcastcontent" v-if="data1.course!=''" style="padding-bottom:37px;">
              <div>
                <div  class="zhi">
                  <div style="text-align:center;">
                     <div class="ke-jie" style="margin-top:40px;">直播内容<div class="ke-t"><div></div><div></div><div></div></div></div>
                     <div class="ke-jie-1">CONTENT</div>
                  </div>
                  <div v-if="data1.special!==undefined" class="zhi-2">
                    <div class="Live_broadcast_form">
                    <template>
                        <el-table stripe :data="data1.course" border  style="width: 100%">
                          <el-table-column   prop="startDate"  label="直播时间"  width = "202px"></el-table-column>
                          <el-table-column  prop="cname"   label="课程主题">
                              <template slot-scope="scope" @click="pudeta(item.cid)">
                                {{scope.row.cname}}
                              </template>
                         </el-table-column>
                          <el-table-column   prop="tName,company"  label="主讲嘉宾" width = "430px'">
                            <template slot-scope="scope">{{scope.row.teacher.tName}} {{scope.row.teacher.degree}}({{scope.row.teacher.company}})</template>
                          </el-table-column>
                        </el-table>
                    </template>
                    </div>
                    <div class="sign_up" @click="baom(data1.special.id)">立即报名</div>
                    </div>
                </div>
              </div>
       </li>
        <!-- 主讲嘉宾 -->
       <li id="keynotespeaker" v-if="teacher"  style="padding-bottom:40px;">
            <div   class="jia">
            <div style="text-align:center;margin-bottom:22px;">
             <div class="ke-jie">主讲嘉宾<div class="ke-t"><div></div><div></div><div></div></div></div>
             <div class="ke-jie-1">DISTINGUISHED GUEST</div>
          </div>
          <div class="sp-auto">
          <div v-if="data1.course!==undefined" class="jia-1">
              <div class="jia-1-1" v-for="(item,i) of data1.course" :key="i">
                  <div class="jia-11-1">
                      <img v-if="item.teacher.headPath==undefined" width="100%" height="100%" src="http://upload.lusenky.com/kt/KTImg/1576814270565.jpg" alt="">
                      <img v-if="item.teacher.headPath!=undefined" width="100%" height="100%" :src="'http://upload.lusenky.com/'+item.teacher.headPath" alt="">
                  </div>
                  <div class="jia-11-2">
                     <p>{{item.teacher.tName}}</p>
                     <p>{{item.teacher.company}}</p>
                     <p :title="item.teacher.introduction">{{item.teacher.introduction}}</p>
                  </div>
              </div>
          </div>
          </div>
        </div>
       </li>
       <!-- 赞助单位 -->
       <li id="sponsor"  v-if="data1.sponsor !=''"  style="padding-bottom:40px;">
           <div  class="zan" >
            <div style="text-align:center">
             <div class="ke-jie">赞助单位<div class="ke-t"><div></div><div></div><div></div></div></div>
             <div class="ke-jie-1">COMPANY</div>
          </div>
           <div class="sp-auto">
           <div class="zan-1" >
              <div v-for="(item,i) of data1.sponsor" :key="i" class="zan-1-1">
                  <div class='zan-11-1'><img width="100%" height="100%" :src="'http://upload.lusenky.com/'+item.logopath" alt=""></div>
                  <div class='zan-11-2'>
                      <p>{{item.corporateName}}</p>
                      <p class="contant" :title="item.company">{{item.company}}</p>
                  </div>
              </div>
           </div>
           </div>
        </div>
       </li>
       <!-- 报名须知 -->
       <li id="Applicationnotes"  style="padding-bottom:40px;">
         <div class="bao">
           <div style="text-align:center;margin-bottom: 22px;">
             <div class="ke-jie">报名须知<div class="ke-t"><div></div><div></div><div></div></div></div>
             <div class="ke-jie-1">CONSULTATION</div>
          </div>
          <div class="signup2">
            <ul>
              <div style="border-right:1px solid rgba(214,214,214,1);">
                  <h3>一、报名提醒</h3>
                  <p>1、请认真填写报名信息，通过审核后才可以顺利学习课程；</p>
                  <p>2、手机和邮箱信息，主要方便直播开课前发送通知，避免错过直播；</p>
                  <p>3、单位和职务便于讲师调整授课范围和深度，请放心填写；</p>
              </div>
              <div style="border-right:1px solid rgba(214,214,214,1);padding:0px 25px 0 25px;width:367px;">
                  <h3>二、学习福利</h3>
                  <p>1、足不出户，使用电脑、手机均可学习；</p>
                  <p>2、添加露丝（微信：lsky201909），加入课程交流群，随时互动交流；</p> 
              </div>
              <div style="padding:0px 0px 0 30px;width:343px;">
                  <h3>三、参会方式</h3>
                  <p>1、加入课程交流群，开课前半小时，注意在群里查收课程入口；</p>
                  <p>2、直播课程前1小时，您将收到短信或邮件提醒。</p>
              </div>
          </ul>
          </div>
        </div>
       </li>
        <!-- 视频回播 -->
       <li id="Videorebroadcast" style="padding-top:60px;"  v-if="checked">
              <div class="shi" >
                   <div style="text-align:center">
                     <div class="ke-jie">视频回播<div class="ke-t"><div></div><div></div><div></div></div></div>
                     <div class="ke-jie-1">REBROADCAST</div>
                  </div>
                  <div class="sp-auto" >
                  <div class="shi-1" >
                      <div class="shi-1-1" style="width:219px;margin-right: 22px;"   v-for="(item,c) of data1.course"  @click="pudeta(item.cid)" :key='c'>
                         <div class="atu" v-if="item.isLive!='0'">
                           <img width="100%"  alt="" :src="'http://upload.lusenky.com/'+item.cPath2">
                         </div>
                         <div class="aubo1">
                           <p class="bo-1">{{item.cname}}</p>
                           <p class="hespan">共有{{item.studyNum}}人学习</p>
                          <div class="he-fon"><span style="font-size: 13px;color:red;">{{item.price==0?'限时免费':`￥ ${item.price}`}}</span><span class="hebtn">立即学习</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                 </div>
              </li>
   </ul>
  </div>
       <div v-if="quBaoming==0" class="body1">
         <div class="body">
             <detailbao ></detailbao>
         </div>
     </div>
     <tanc  @tancNone="isn=false" v-if="isn"></tanc> 
     <myfoot></myfoot>
 </div>
</template>
<script>
import myhead from "./spheader.vue"
import myfoot from "../common/Myfoot"
import tanc from '../tanc'
import detailbao from '../detailBao'
import router from "../../router";
 export default {
  data () {
   return {
     /*登陆的*/
    isLo:0,
    isbao:false,
    isn:false,
    sponsor:true,
    active:0,
    checked:true,
    quBaoming:1,
    data1:[],
    names: ['000', '111'],
    istabBar: false,
    Videorebroadcast:true,
    dataLive:[],
    data2Live:[],
    data2:[],
    teacher:true,
    addtime:'',
    hb:''
   }
  },
  methods: {
 
      tId(id){
          this.quBaoming=1
          setTimeout(() => {
            var id1=document.getElementById(id)
            id1.scrollIntoView()  
          }, 100);
      },
  /*获取直播视频课 */
       getlive(){
         var templist = []
         this.axios.get('course/live').then((res)=>{
         this.goods = res.data
         this.dataLive=res.data.filter((val)=>{return val.isLive==0})
         this.data2Live=res.data.filter((val)=>{return val.isLive==1})
        
       });
    },
         /*跳转详情页 */
       pudeta(id){
          this.$router.push({path:'/detail',query:{id}})
       },
         /*登陆系列的方法 */
      tui(){
        this.setCookie('id','',-1)
        location.reload()
      },
       setCookie(name, value, time){
        let currentTime = new Date().getTime();
        let expireTime = new Date(currentTime + time);
        document.cookie = name + "="+ value + ";expires=" + expireTime.toGMTString();        
      },
        getCookie(name){
          let strCookie = document.cookie; 
          let arrCookie = strCookie.split(';'); 
          // 遍历匹配
          for (let i = 0; i < arrCookie.length; i++) {
              let temp = arrCookie[i].trim().split('=');
              if (temp[0] === name) {
                  return temp[1];
              }
          }
          return '';
       },
       getDing(st,pa,id){
          this.axios.get('order/fen',{params:{
            start:st,
            pageSize:pa,
            uid:id
         }}).then((res)=>{
          var arr=res.data.map((val)=>{
            return val.course.cid
         })
         this.$store.commit('baoIds',arr)
       /*  this.isBao()*/
       })
      },
        isLogin(){
         let id=this.getCookie('id')
         if(id!==''){
            this.getDing(1,10,id)
            this.$store.commit('dengLu')
            this.$store.commit('userIsId',id)
         }else{
           this.$store.commit('dengNo')
         }
        },
        baom(){
           this.quBaoming=0
        },
            // 添加一个方法 兼容
         handleScroll () {
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
           // 固定导航栏
           let topBar = document.querySelector("#topPart");
           let navBar = document.querySelector("#navBar");
           let mainPart = document.querySelector("#mainPart");
           if (scrollTop > topBar.offsetHeight){
            this.istabBar = true
            mainPart.style.paddingTop = navBar.offsetHeight + "px";
           } else {
            this.istabBar = false
            mainPart.style.paddingTop = "0px";
           }
         }
        },
        mounted () {
         window.addEventListener('scroll', this.handleScroll); 
        },
        destroyed () {
         window.removeEventListener('scroll', this.handleScroll) 
        },

        created(){
               if(/Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(navigator.userAgent)) {
                window.location.href = " http://lskt.lusenky.com/#/indexs?id="+this.$route.query.id;
            }
            this.hb=this.$route.query.hb
            if(this.hb==2){
                $('html,body').animate({
                        scrollTop: 5000
                    }, 1000)
            }
          this.axios.get('spe/byc2?id='+this.$route.query.id).then((res)=>{
              this.data1=res.data[0];
              var href= window.location.href
              href = unescape(href)
              console.log(href)
              console.log(href.charAt(href.length-1))

              if(JSON.stringify(res.data) == "[]"){
                  // if (href.charAt(href.length)=='0')
                  // console.log("jump")
                  this.$router.push({path:'/detail?id='+this.$route.query.id})
                  // window.history.back(-1)
              }else{
                  this.data2 = res.data[0].course
                  for(var i=0;i<this.data2.length;i++){
                      console.log(this.data2[i].isLive)
                      if(this.data2[i].isLive =='0'||this.data2.length==0){
                          this.checked = false
                      }else if(this.data2[i].teacher ==[]){
                          this.teacher =false
                      }
                      console.log(this.data2[i].length)
                  }
              }

                
          })
          this.isLogin()
          this.getlive()
        },
    components:{
        myfoot,
        myhead,
        tanc,
        detailbao
    }
 }
</script>
 
 
<style scoped>
.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #d6d6d6;
}
.el-table__row .el-table_1_column_1,.el-table_1_column_2,.el-table_1_column_3{
  color:#000;
}
.el-table__row .el-table_1_column_2:hover{
    color:rgba(99,43,136,1);
    cursor:pointer;
}
 @media  (max-width:1920px){
  .bannerimg{
   width:100%;
  }
}
@media  (max-width:1200px){
 .bannerimg{
   width:100%;
  }
}
.body{
    width: 1200px;
    margin:0 auto;
}
.body1{
    background: #E8E8E8;
    padding: 25px 0 30px;
}
#CurriculumBG:before{
    content: "";
    display: block;
    margin-top: -60px !important;
    height: 60px;
    pointer-events: none;
}
#Livebroadcastcontent:before{
    content: "";
    display: block;
    margin-top: -60px !important;
    height: 60px;
    pointer-events: none;
} 
#keynotespeaker:before{
    content: "";
    display: block;
    margin-top: -60px !important;
    height: 85px;
    pointer-events: none;
}
#Applicationnotes:before{
   content: "";
    display: block;
    margin-top: -60px !important;
    height: 85px;
    pointer-events: none;
}
#sponsor:before{
    content: "";
    display: block;
    margin-top: -60px !important;
    height: 80px;
    pointer-events: none;
}
#Videorebroadcast:before {
    content: "";
    display: block;
    margin-top: -60px !important;
    height: 60px;
    pointer-events: none;
}
#oTable li:nth-of-type(2n+1){background:#ffffff}
#oTable li:nth-of-type(2n+2){background:#f5f5f5}
   .on {
      background: #f5f5f5;
    }
    .off {
      background: #ffffff;
    }
.headertop{
    background: #F3F3F3;
    padding: 7px 0;
}
.header-1{
    width: 1200px;
    margin:0 auto;
    display: flex;
    justify-content: space-between;
}
.header-1-1{
    display: flex;
}
.header-1-1>div{
    font-size: 10px;
    margin-left: 14px;
    font-weight:600;
    color:rgba(47,47,47,1);
    display: flex;
    align-items: center;
}
.header-1-2{
    display: flex;
    justify-content: space-around;
    width: 320px;
    font-size:14px;
    font-weight:400;
    color:rgba(47,47,47,1);
}
.header-1-2>div{
    width: 200px;
    text-align: center;
    height: 37.8px;
    line-height: 37.8px;
    position: relative;
    cursor: pointer;
}
.header-1-2>div:hover{
    color: #632B88;
}
/*头部第二曾的样式 */
.header2{
    background:#ffffff;
}
.header2-1{
    width: 1200px;
    padding-top: 15px;
    padding-bottom: 15px;
    margin: 0 auto;
    display: flex;
    align-items: center;
}
.header2-1-2{
    display: flex;
    margin-left: 68px;
}
.header2-1-2>div{
    font-size:18px;
    font-weight: 600;
    margin:0 32px;
    color: #2F2F2F;
    cursor: pointer;
}
.header2-1-2>div:hover{
    color: #632B88;
}
.header2-btn{
    width:94px;
    height:37px;
    background:rgba(99,43,136,1);
    border-radius:5px;
    color: #fff;
    font-size: 17px;
    font-weight: 600;
    text-align: center;
    line-height: 37px;
    cursor: pointer;
    margin-left: 21px;
}
.signup2{
    width:1200px;
    margin:0 auto;
    height: 158px;
}
.signup2 ul {
    float:left;
}
.signup2 ul div{
    float:left;
    
}
.signup2 ul div h3{
    font-size:18px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(0,0,0,1);
    line-height:33px;
}
.signup2 ul div p{
    font-size:13px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(42,42,42,1);
    line-height:33px;
}
.Live_broadcast_form{
    margin-top:54px;
    padding-bottom:56px;
}
.sign_up{
    width:112px;
    height:47px;
    border:1px solid #000000;
    border-radius:10px;
    font-size:18px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(0,0,0,1);
    text-align: center;
    cursor: pointer;
    margin: 0 auto;
    line-height:47px;
}
.sign_up:hover{
    color:rgba(99,43,136,1);
    border:1px solid rgba(99,43,136,1)
}
.ke{
    width: 1200px;
    margin: 52px auto 0;
}
.ke-jie{
    display: inline-block;
    font-size:36px;
    font-family:'Microsoft YaHei';
    font-weight:bold;
    color:rgba(0,0,0,1);
    margin:0 auto;
    position: relative;
}
.ke-t{
    height: 7px;
    width: 100%;
    position: absolute;
    bottom: -13px;
    z-index: 2;
    display: flex;
}
.ke-t>div:first-child{
    width:72px;
    height:7px;
    background:rgba(99,43,136,1);
    border-radius:4px;
    margin-right: 6px;
}
.ke-t>div:nth-child(2){
   width:17px;
    height:7px;
    background:rgba(99,43,136,1);
    border-radius:4px;
    margin-right: 12px;
}
.ke-t>div:last-child{
   width:28px;
    height:7px;
    background:rgba(99,43,136,1);
    border-radius:4px;
}
/* */
.ke-jie-1{
    font-size:48px;
    font-family:'Microsoft YaHei';
    font-weight:bold;
    font-style:italic;
    color:rgba(215,215,215,1);
    position: relative;
    top: -17px;
}
.ke-jian{
    font-size:19px;
    font-family:'Microsoft YaHei';
    font-weight:400;
    color:rgba(48,48,48,1);
    line-height:36px;
    margin:20px 0 60px;
}
/*直播内容 */
.zhi,.jia{
    width: 1200px;
    margin:0px auto 100px;
}
.jia{
    margin:0px auto 40px;
}
.zhi-2{
    text-align: center;
}
.zhi-2>p{
    font-size:24px;
   font-weight:bold;
   margin-top: 15px;
}
.contant{
    color: #545454;
    font-size: 16px;
    margin-top: 14px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}
.zhi-2>p:last-child{
    margin-bottom:37px;
}
.zhi-3{
    display: flex;
}
.zhi-3-1{
    width: 620px;
    height: 350px;
    position: relative;
    background: red;
}
.zhi-3-1-1{
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 80px;
    background:rgba(0,0,0,.4);
    box-sizing: border-box;
    padding:0 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.zhi-3-1-1-1{
    display: flex;
}
.zhi-3-1-1-1>div:first-child{
  width: 46px;
  height: 46px;
  box-sizing: border-box;
  border-radius: 50%;
  overflow: hidden;
  border:2px solid rgba(255, 255, 255, 1);
}
.zhi-3-1-1-1>div:last-child{
    color: #fff;
    margin-left: 15px;
}
.zhi-3-1-btn{
    width:180px;
    height:60px;
    background:rgba(99,43,136,1);
    border-radius:5px;
    text-align: center;
    box-sizing: border-box;
    padding-top:5px; 
}
.zhi-3-1-btn>p:first-child{
  color: #fff;
  font-size:20px;
}
.zhi-3-1-btn>p:last-child{
  color: #ED8AD8;
  font-size: 14px;
}
.zhi-3-2{
    width: 580px;
    height: 350px;
}
.zhi-3-2-1{
    height: 50px;
    width: 100%;
    display: flex;
    cursor: pointer;
    transition: .3s ;
}
.zhi-321-1{
    width: 48px;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    border-right:1px dotted #a9a5a5;
}
.zhi-321-1>div{
   width: 9px;
   height: 9px;
   position: absolute;
   top: 42%;
   right: -5px;
   border-radius: 50%;
}
.zhi-321-p{
    margin-left: 96px;
    line-height: 50px;
    width: 200px;
}
.zhi-321-2{
    width: 150px;
    margin-left: 48px;
    line-height: 50px;
}
.zhi-321-3{
    line-height: 50px;
}
/*选中后的样式 */
.active{
    background: #fff;
    box-shadow:0px 3px 5px 0px rgba(153,153,153,0.3);
    position: relative;
    z-index: 88;
}
.active>.zhi-321-1{
    border-left: 5px solid #632b88;
    border-right: 1px dotted #632b88;
}
.active>.zhi-321-1>div{
    background: #632B88;
}
.active>.zhi-321-2,.active>.zhi-321-3{
    color: #632B88;
}
/*主讲嘉宾 */
.jia-1,.zan-1{
    display: flex;
    width: 1226px;
    flex-flow: wrap;
    margin:20px auto;
}
.jia-1-1{
    width: 587px;
    margin-right: 26px;
    margin-bottom:26px;
    box-sizing: border-box;
    padding: 40px 0;
    display: flex;
    justify-content: space-around;
    box-shadow:0px 0px 4px 0px rgba(0, 0, 0, 0.2);
}
.jia-11-1{
  width: 162px;
  height: 162px;
  border-radius: 50%;
  background: #000;
  overflow: hidden;
}
.jia-11-2{
  width: 368px;
}
.jia-11-2>p:first-child{
  font-size:24px
}
.jia-11-2>p:nth-child(2){
  color:#292929;
  font-size: 21px;
  margin-top:14px;
}
.jia-11-2>p:last-child{
  color: #545454;
  font-size: 16px;
   margin-top:14px;
   overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp:3;
}
/* 赞助单位*/
.zan,.shi{
    padding: 0px 0 77px;
}
.zan-1-1{
    width: 587px;
    margin-right: 26px;
    background: #fff;
    box-sizing: border-box;
    padding: 60px 49px;
    display: flex;
    margin-bottom:20px;
}
.zan-11-1{
    width: 230px;
    height: 110px;
    margin-right: 10px;
}
.zan-11-2{
    width: 240px;
}
.zan-11-2 p{
    /* overflow: hidden;777777777777777768 */
}
.zan-11-2>p:first-child{
    font-size:18px;
    font-weight: 600;
}
.zan-11-2>p:last-child{
    color: #545454;
    margin-top: 24px;
}
/*报名咨询 */
.bao{
    padding: 0px 0 50px;
}
.bao-2{
    width: 520px;
    margin:0 auto;
}
.bao-2>h3{
    margin: 10px 0;
}
.bao-2>h3:first-child{
    margin-bottom: 10px;
}
.bao-2>p{
    margin-bottom: 7px;
}
/*视频回播 */
.shi-1{
    width: 1253.3px;
    margin:0 auto;
    display: flex;
}
.shi-1-1{
    width: 260px;
    margin-right: 53.3px;
    cursor: pointer;
    position: relative;
    border-radius: 5px;
    overflow: hidden;
    box-sizing: border-box;
}
.atu{
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height:130px;
  background: #000;
  overflow: hidden;
  position: relative;
}
.bo-1{
  color: #313131;
  font-size: 14px;
  height: 40px;
}
.aubo1{
 box-sizing: border-box;
 padding: 15px;
 border: 1px solid #f1eaea;
 border-top:none;
 background: #fff;
}
.he-fon{
  display: flex;
  justify-content: space-between;
}
.hebtn{
  display: block;
  color: #8A8A8A;
  border: 1px solid #8A8A8A;
  padding: 2px 5px;
  font-size: 11px;
  border-radius: 5px;
}
.aubo1:hover .hebtn{
  color: #877BB8;
  border: 1px solid #877bbb;
}
.hespan{
  font-size: 12px;
  color: #8A8A8A;
  height: 35px;
}
.sp-auto{
    width: 1200px;
    margin: 0 auto;
}
/* 登陆*/
.list{
  position: relative;
  cursor: pointer;
  background: #c1c1c1;
  overflow: hidden;
  transition: .5s;
  z-index: 9999;
}
.list>li{
    line-height:initial;
  padding: 6px 0;
}
.list>li:hover{
  background: #5E2D89;
  color: #fff;
}
/* 头部 */
 #topPart{
  width: 100%;
  height: 50px;
 }
 .isFixed {
  position: fixed;
  top: 0;
  z-index: 10;
 }
 #navBar {
  width: 100%;
  height: 50px;
 }
 #mainPart {
  width: 100%;
 }
 #mainPart ul {
  width: 100%;
 }
 #mainPart ul li {
  margin-bottom: 10px;
 }
</style>
